import React, { useCallback } from 'react'
import { useDropzone } from 'react-dropzone'

import { makeStyles, Theme } from '@material-ui/core/styles'

const useStyles = makeStyles((theme: Theme) => ({
  dropzone: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    borderWidth: '2px',
    borderRadius: '2px',
    borderColor: '#eeeeee',
    borderStyle: 'dashed',
    backgroundColor: '#fafafa',
    color: '#bdbdbd',
    outline: 'none',
    transition: 'border .24s ease-in-out',
    cursor: 'pointer'
  }
}))

const Dropzone: React.FC<{
  dropHandler: (files: File[]) => void
  accept: string
}> = ({ dropHandler, accept }) => {
  const classes = useStyles({})

  const onDrop = useCallback(
    (acceptedFiles: File[]) => {
      if (acceptedFiles.length === 0) {
        alert('ファイル形式は PDF/JPG/GIF/PNG で登録してください。')
      }
      dropHandler(acceptedFiles)
    },
    [dropHandler]
  )

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: accept
  })

  return (
    <div {...getRootProps()} className={classes.dropzone}>
      <input {...getInputProps()} />
      {isDragActive ? (
        <p>ここにファイルをドロップしてください</p>
      ) : (
        <p>ファイルをドラッグドロップ、またはファイルを選択するためにクリックしてください</p>
      )}
    </div>
  )
}

export default Dropzone
